import React from "react";
import { FiEdit3, FiRefreshCw } from "react-icons/fi";

export const shouldShowPreviewCreditActions = ({
  isPlaying,
  isFullscreen,
  isRenderExport,
  isRenderPage,
}) => !isPlaying && !isFullscreen && !isRenderExport && !isRenderPage;

const PreviewCreditActions = ({
  isVisible,
  canOpenCreditSheet,
  canSyncCredits,
  isSyncing,
  onOpenCreditSheet,
  onSyncCredits,
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="previewCreditActions"
      data-html2canvas-ignore="true"
      aria-label="Credit Sheet actions"
    >
      <button
        type="button"
        className="previewCreditAction"
        aria-label="Edit Credit Sheet"
        data-tooltip="Edit Credit Sheet"
        disabled={!canOpenCreditSheet}
        onClick={onOpenCreditSheet}
      >
        <FiEdit3 aria-hidden="true" />
      </button>
      <button
        type="button"
        className="previewCreditAction"
        aria-label="Sync Credits"
        data-tooltip={isSyncing ? "Syncing..." : "Sync Credits"}
        disabled={!canSyncCredits || isSyncing}
        onClick={onSyncCredits}
      >
        <FiRefreshCw
          className={isSyncing ? "previewCreditActionIcon--spinning" : ""}
          aria-hidden="true"
        />
      </button>
    </div>
  );
};

export default PreviewCreditActions;
